
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"15","viewBox":"0 0 9 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.07 14.37C1.72206 14.7179 1.15794 14.7179 0.810001 14.37C0.462062 14.0221 0.462062 13.4579 0.810001 13.11L5.77289 8.14711C6.16342 7.75658 6.16342 7.12342 5.77289 6.73289L0.810001 1.77C0.462062 1.42206 0.462062 0.857941 0.810001 0.510002C1.15794 0.162063 1.72206 0.162063 2.07 0.510003L8.29289 6.7329C8.68342 7.12342 8.68342 7.75658 8.29289 8.14711L2.07 14.37Z","fill":"white"}})])
          )
        }
      }
    